// CYBORG-1525: per workspace, the unread alerts the relay's total counts in a channel archived for
// me. The badge takes them off for workspaces NOT open here (the open one: ActivityState.hiddenUnread).

export type HiddenUnreadByWorkspace = Record<string, number>;

export interface BadgeAck {
  unread: number;
  totalUnread?: number;
  hiddenUnreadByWorkspace?: HiddenUnreadByWorkspace;
}

// Undefined when the relay sent none (it predates the field).
export function readHiddenSplit(value: unknown): HiddenUnreadByWorkspace | undefined {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return undefined;
  const out: HiddenUnreadByWorkspace = {};
  for (const [workspaceId, n] of Object.entries(value)) {
    if (typeof n === "number" && Number.isFinite(n) && n > 0) out[workspaceId] = Math.floor(n);
  }
  return out;
}

// The relay's own count, whatever rows this session holds: it is taken off the relay's total.
export function hiddenElsewhere(
  split: HiddenUnreadByWorkspace | undefined,
  openWorkspaceId: string | undefined,
): number {
  if (!split) return 0;
  let hidden = 0;
  for (const [workspaceId, n] of Object.entries(split)) {
    if (workspaceId !== openWorkspaceId) hidden += n;
  }
  return hidden;
}
